import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'

Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

const Toast = {
    methods: {
        Toast(title, message, type) {
            type = type.toLowerCase()
            let toastType = "";
            let iconClass = '';

            switch (type) {
                case 'error':
                    type = 'danger'
                    toastType = "toast-" + type;
                    iconClass = 'fas fa-times-circle'
                    break
                case 'success':
                    type = "success";
                    toastType = "toast-" + type;
                    iconClass = 'fas fa-check-circle'
                    break
                case 'confirm':
                    this.AlertConfirm(title, message)
                    break
            }
            const h = this.$createElement;
            const titleNodes = h(
                'div',
                { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
                [
                    h('i', {class: iconClass + ' toast-icon'}),
                    h('strong', { class: 'mr-2' }, title)
                ]
              );

            this.$bvToast.toast(message, {
                title: titleNodes,
                variant: type,
                noAutoHide: false,
                toastClass: toastType,
                solid: true,
                noCloseButton:true,
                autoHideDelay: 6000
            })
        },
        AlertConfirm(title, message) {
            return this.$bvModal.msgBoxConfirm(message, {
                title: title,
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'Si',
                cancelTitle: 'No',
                footerClass: 'p-2',
                hideHeaderClose: true,
                centered: true,
            })
        },
        AlertValidationError(){
            this.Toast('Información incompleta', 'Favor completar la información solicitada.', 'error');
        }
    },
}

Vue.mixin(Toast)
